import { MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader, MDBModalTitle, MDBSpinner } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import {
  getCallFlows,
  getMisc,
  updateCallFlows,
} from "../../apiclients/streamsapi_bridge";
import Body from "../../components/body/BodyPage";
import MainLinks from "../../components/navlinks/MainLinks";
import PopupLoader from "../popups/PopupLoader";
import AddCallFlow from "../popups/callflow/AddCallFlow";
import DeleteCallFlow from "../popups/callflow/DeleteCallFlow";
import EditCallFlow from "../popups/callflow/EditCallFlow";

import {
  AddRemoveNumbers,
  formattedNumber,
  unFormatNumber,
} from "../popups/phonenumbers/AddRemoveNumbers";
import DeleteNumbers from "../popups/phonenumbers/DeleteNumbers";
import { Tooltip } from "react-tooltip";
import PopupLoaderNew from "../popups/PopupLoaderNew";
import useWindowManager from "../../components/useWindowManager";
import  { customSearch, useAutoFocusSearchAfterLoads } from "../../components/CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import TabIDConstant from "../../apiclients/TabIDConstant";
import { getImpExpStatusNew } from "../../apiclients/CommonUtils";
import ImportProgressWarning from "../../apiclients/ImportProgressWarning";
import ImpExpRedirectPopup from "../../apiclients/ImpExpRedirectPopup";
import ImportUser from "../../components/editviews/user/ImportUser";

function CallFlowLanding() {
  const { openOrMessageWindow } = useWindowManager();
  const [isloading, setIsloading] = useState(false);

  const [callFlows, setCallFlows] = useState([]);
  const [copyselected, setCopyselected] = useState([]);

  const [savedPhoneNumbers, setSavedPhoneNumbers] = useState([]);

  const location = useLocation();
  const [AddHoliday, setAddHoliday] = useState(location.state ? location.state.openadd : false);
  const [editCallFlow, seteditCallFlow] = useState(false);
  const [delCallFlow, setdeleteCallFlow] = useState(false);
  const [callflow, setCallflow] = useState(-1);
  const addNumberRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [callFlowDetails, setCallFlowDetails] = useState([]);
  const [showExportWarning, setShowExportWarning] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
  const exportwarningToggle = () => setShowExportWarning(!showExportWarning);
  const [warningMessage, setWarningMessage] = useState("");
  const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);
  const [importUser, setimportUser] = useState(false);
  const importuserToggle = () => setimportUser(!importUser);
  const [firstRequest, setfirstRequest] = useState(false);

  function handleClick() {
    addNumberRef.current.click();
  }

useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef)
  const addNewCallflow = () => {
    setCopyselected([]);
     window.history.replaceState({}, document.title);
    setAddHoliday(!AddHoliday);
  };
  const editCallFlowToggle = () => seteditCallFlow(!editCallFlow);
  const deleteCallFlowToggle = () => setdeleteCallFlow(!delCallFlow);

  const navigate = useNavigate();
  let windowsMap = {};
  async function navigeteToCallFlow(tdata) {
    setCopyselected(null);
    const response = await getCallFlows(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid
    );
    const rawData = await response.json();
    let tempcallflow = rawData.call_flows.filter(
      (cf) => cf.name === tdata.name
    );
    let tflows = tdata.new ? [tempcallflow[0], ...callFlows] : [...callFlows];

    console.log(
      "--------------------------------------------------------------"
    );
    console.log(localStorage.getItem("veditor_cfid"));
    const state_old = {
      callflow: JSON.parse(localStorage.getItem("veditor_cfid")),
      callflow_list: tflows.sort((a, b) => a?.name?.localeCompare(b?.name)),
    };
    localStorage.setItem("callflowState_old", JSON.stringify(state_old));
    localStorage.setItem(
      "veditor_cfid_old",
      localStorage.getItem("veditor_cfid")
    );
    const state = {
      callflow: tempcallflow[0],
      callflow_list: tflows.sort((a, b) => a?.name?.localeCompare(b?.name)),
    };
    localStorage.setItem("callflowState", JSON.stringify(state));
    localStorage.setItem("veditor_cfid", JSON.stringify(tempcallflow[0]));
    const windowName = `callflowWindow`;

    openOrMessageWindow(windowName, "/ai-call-flow", {
      veditor_cfid: tempcallflow[0],
      callflowState: state,
    });
    window.history.replaceState({}, document.title);
    window.location.reload();
    // // Check if the window with this name already exists
    // if (windowsMap[windowName] && !windowsMap[windowName].closed) {
    //   // Focus on the existing window if it's already open
    //   windowsMap[windowName].focus();
    //   windowsMap[windowName].location.reload(); // Reload the window content
    // } else {
    //   // Open a new window and store its reference in windowsMap
    //   windowsMap[windowName] = window.open(
    //     "/ai-call-flow",
    //     windowName
    //     // 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes'
    //   );
    // }
    // if (tdata.new) {
    //   window.location.reload();
    // }
  }

  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  async function fetchData() {
    setIsloading(true);
    sessionStorage.setItem("current_link", "callflowlanding");
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getCallFlows(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      TabIDConstant.CALL_FLOWS_LINK
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const rawData = await response.json();
    if (!rawData) {
      window.alert(`info with id not found`);
      navigate("/");
    }
    console.log("call flow data ::::::::::::", JSON.stringify(rawData));

    console.log("From edit page receiving state ", location?.state);
    if (location?.state && location?.state?.flag == 1) {
      const callFlowdata = rawData.call_flows.find(
        (item) => item.call_flow_id == location.state.id
      );
      console.log("callFlowdata edited ::::::::::::", callFlowdata);
      navigate("/callflowedit", {
        state: { call_flow: callFlowdata },
      });
    }

    setCallFlows(rawData.call_flows);
    setIsloading(false);
    setDataLoaded(true)
  }

  const editCallF = (e, obj) => {
    e.preventDefault();
    e.stopPropagation();
    setCallflow(obj);
    console.log(callFlows);
    console.log("Navigate obj ::::::::::::", obj);
    navigate("/callflowedit", {
      state: { call_flow: obj },
    });
  };
  const deleteCallFlow = (e, obj) => {
    e.preventDefault();
    e.stopPropagation();
    setCallflow(obj);
    deleteCallFlowToggle();
  };
  const copyCallFlow = (e, obj) => {
    e.preventDefault();
    e.stopPropagation();
    setCopyselected(obj);
    setAddHoliday(!AddHoliday);
  };

  const [AddNumbers, setAddNumbers] = useState(false);
  const toggleNumbers = (e, tObj) => {
    setAddNumbers(!AddNumbers);
  };
  const openNpopup = (e, tObj) => {
    setAddNumbers(!AddNumbers);
    console.log(tObj);
    setCallflow(tObj);
  };
  const [isdeleteNumber, setIsDeleteNumbers] = useState(false);
  const dtogglePopup = () => setIsDeleteNumbers(!isdeleteNumber);

  const handleDelete = (number) => {
    const unformatNum = unFormatNumber(number);
    dtogglePopup();
    setUpdatePHNum([unformatNum]);
  };

  useEffect(()=>{
  let proccessdRows = [];
  callFlows.map((cflow, index) => {
    let phNumber = "";
    cflow.added_dids.map((ph) => {
      phNumber += formattedNumber(ph) + ", ";
    });
    proccessdRows.push({
      call_flow_id: cflow.call_flow_id,
      name: cflow.name + "",
      extension: cflow.extension + "",
      actualNumber : phNumber?.toString().replace(/[ ]/g, ''),
      number: cflow?.added_dids?.length >1 ? formattedNumber(cflow?.added_dids[0]) + ", ..." : cflow?.added_dids?.length === 1 ? formattedNumber(cflow?.added_dids[0]) : "",
      anumber: cflow.added_dids ?? "",
      location_name: cflow.location_name ?? "",
      actions: (
        <>
          {/* <div className="d-flex justify-content-center align-items-center">
            <a
              style={{ zIndex: 9996 }}
              href="#"
              onClick={(e) => copyCallFlow(e, cflow)}
            >
              <MDBIcon
                far
                icon="copy"
                color="primary"
                className="fs-5"
                title="Copy"
              />
            </a>

            <a
              className="mx-3"
              style={{ zIndex: 99996 }}
              href="#"
              onClick={(e) => editCallF(e, cflow)}
              target="_new"
            >
              <MDBIcon
                fas
                icon="edit"
                color="primary"
                className="fs-6"
                title="Edit"
              />
            </a>

            <a
              style={{ zIndex: 99996 }}
              href="#"
              onClick={(e) => deleteCallFlow(e, cflow)}
              target="_new"
            >
              <MDBIcon
                fas
                icon="times"
                color="primary"
                className="fs-4"
                title="Remove"
              />
            </a>
          </div> */}

          <div className="d-flex align-items-center ms-2 justify-content-center">
            <div
              className="custom-hover-bg p-1 cursor-pointer copyToolTip"
              onClick={(e) => copyCallFlow(e, cflow)}
            >
              <MDBIcon far icon="copy" color="primary" className="m-1 fs-5" />
            </div>

            <div
              className="custom-hover-bg p-1 cursor-pointer editToolTip ms-2"
              onClick={(e) => editCallF(e, cflow)}
            >
              <MDBIcon fas icon="edit" color="primary" className="m-1 fs-5" />
            </div>

            <div
              className="custom-hover-bg p-1 cursor-pointer deleteToolTip ms-2"
              onClick={(e) => deleteCallFlow(e, cflow)}
            >
              <MDBIcon
                fas
                icon="times"
                color="primary"
                className="mx-2 my-1 fs-5"
              />
            </div>
          </div>
        </>
      ),
    });
  });
  setFilteredRows(proccessdRows)
  setCallFlowDetails(proccessdRows)
},[callFlows])
  const actionData = {
    columns: [
      { label: "Name", field: "name", sort: true },
      { label: "Extension", field: "extension", sort: true },
      { label: "Number", field: "number", sort: true },
      { label: "Location", field: "location_name", sort: true },
      { label: "Actions", field: "actions", sort: false },
    ],
    rows: callFlowDetails,
  };
  
  const handleManualSearch = (searchValue) => {
    setSearchValue(searchValue);
    const filtered = customSearch(callFlowDetails, searchValue, UIConstant.CALL_FLOW_LANDING);

    setFilteredRows(filtered);
  };

  const [sourceNumber, setSourceNumber] = useState([]);
  const [updatePHNum, setUpdatePHNum] = useState([]);

  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
  const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);

  useEffect(() => {
    if (updatePHNum.length > 0 && updateNumbersExecuted) {
      addPhoneNumbers("added_dids");
      setUpdateNumbersExecuted(false);
    }
  }, [updatePHNum, updateNumbersExecuted]);

  useEffect(() => {
    if (updatePHNum.length > 0 && deleteNumberFlag) {
      addPhoneNumbers("removed_dids");
      setDeleteNumberFlag(false);
    }
  }, [updatePHNum, deleteNumberFlag]);
  async function addPhoneNumbers(fieldName) {
    console.log(callflow);
    let update = {
      reqid: 55,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      call_flow_id: callflow.call_flow_id,
      [fieldName]: updatePHNum,
    };

    console.log(JSON.stringify(update));
    console.log(JSON.stringify(update));
    let saverep = await updateCallFlows(update);
    console.log(saverep);
    let saverepeMsg = await saverep.json();
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      //debugger;
      if (fieldName === "added_dids") {
        setSavedPhoneNumbers((prev) => [...prev, ...updatePHNum]);
        //setSuccessMessage(`Telephone Number ${updatePHNum} added successfully`);
      } else {
        const updateAddPHNum = savedPhoneNumbers.filter(
          (num) => !updatePHNum.includes(num)
        );
        setSavedPhoneNumbers(updateAddPHNum);
        // setSuccessMessage(
        //   `Telephone Number ${updatePHNum} removed successfully`
        // );
      }
    } else {
      if (fieldName === "removed_dids") {
        const modifynum = savedPhoneNumbers.filter(
          (num) => !updatePHNum.includes(num)
        );
        setSavedPhoneNumbers([...modifynum, ...updatePHNum]);
      }
    }
  }

  async function getFreePhoneNumbers() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["free_dids"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + basicInfo);
    setSourceNumber(basicInfo.misc.free_dids);
  }

  useEffect(() => {
    getFreePhoneNumbers();
  }, []);
  /********************************Fetching Display Data Starts Here!************************************************* */
  useEffect(() => {
    fetchData();
  }, []);
  /********************************************************************************* */

  const handleImportAndPrgress = async (e) => {
    e.preventDefault();
    const result = await getImpExpStatusNew();
    if (result.status === 0) {
      addNewCallflow();
    } else if (result.isOwnUser) {
      setShowImpExpRedirect(true);
    } else {
      const { userInfo } = result;
      if (userInfo?.isaccount) {
        setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
      } else {
        setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
      }
      exportwarningToggle();
    }
  }

  return (
    <React.Fragment>
      <>
        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={41}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header px-0">
                    <h5 className="mb-0 ">{t("CallFlows")}</h5>
                  </div>
                  <div className="card-body px-0">
                    <div className=" actionbar">
                      <MDBBtn
                        onClick={(e) => handleImportAndPrgress(e)}
                        className="float-end mt-6px"
                      >
                        <MDBIcon fas icon="plus" className="me-2" />
                        {t("addcallFlow")}
                      </MDBBtn>
                    </div>

                    <div className='mb-2 mt-0 position-relative w-auto'>
                      <MDBInput
                        label="Search"
                        ref={searchRef}
                        value={searchValue}
                        onChange={(e) => handleManualSearch(e.target.value)}
                      />
                      <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                    </div>
                    <div className="callFlowTable">
                      <MDBDatatable key={searchValue}
                        sortField="Name"
                        className="actioncolumnbig"
                        onRowClick={(event, rowData) => {
                          navigeteToCallFlow(event, rowData);
                        }}
                        // search
                        entries={50}
                        data={{...actionData,
                          rows:filteredRows
                        }}
                      />
                    </div>
                  </div>
                  {AddHoliday && (
                    <>
                      <PopupLoader
                        title={t("addcallFlow")}
                        content={
                          <AddCallFlow
                            onSucess={navigeteToCallFlow}
                            onClose={addNewCallflow}
                            oncopy={copyselected}
                          />
                        }
                        onShow={setAddHoliday}
                        onClose={addNewCallflow}
                      />
                    </>
                  )}
                  {editCallFlow && (
                    <>
                      <PopupLoader
                        title={t("editcallFlow")}
                        content={
                          <>
                            <EditCallFlow
                              onClose={editCallFlowToggle}
                              call_flow={callflow}
                            />
                          </>
                        }
                        onShow={seteditCallFlow}
                        onClose={editCallFlowToggle}
                      />
                    </>
                  )}
                  {delCallFlow && (
                    <PopupLoader
                      title={"Remove Call Flow"}
                      content={
                        <DeleteCallFlow
                          call_flow={callflow}
                          onClose={deleteCallFlowToggle}
                        />
                      }
                      onShow={setdeleteCallFlow}
                      onClose={deleteCallFlowToggle}
                    />
                  )}
                </div>
              </section>
              {isloading && (
                <>
                  <div className="loadingclass">
                    <MDBBtn disabled>
                      <MDBSpinner
                        size="sm"
                        role="status"
                        tag="span"
                        className="me-2"
                      />
                      Loading...
                    </MDBBtn>
                  </div>
                </>
              )}
              {AddNumbers && (
                <PopupLoaderNew
                  // size="lg"
                  // className="modal-lg"
                  title={"Add Numbers"}
                  content={
                    <AddRemoveNumbers
                      selectedNum={savedPhoneNumbers ? savedPhoneNumbers : []}
                      setUpdatePHNum={setUpdatePHNum}
                      setUpdateNumbersExecuted={setUpdateNumbersExecuted}
                      onClose={toggleNumbers}
                      sourceNumber={sourceNumber}
                      ref={addNumberRef}
                      setIsloading={setisLoading}
                    />
                  }
                  onShow={setAddNumbers}
                  onClose={toggleNumbers}
                  onSave={handleClick}
                  isloading={isLoading}
                  flag={1}
                />
              )}

              {isdeleteNumber && (
                <PopupLoaderNew
                  title={"Remove Phone Number"}
                  content={
                    <DeleteNumbers
                      onClose={dtogglePopup}
                      setDeleteNumberFlag={setDeleteNumberFlag}
                      ref={addNumberRef}
                      setIsloading={setisLoading}
                    />
                  }
                  onShow={setIsDeleteNumbers}
                  onClose={dtogglePopup}
                  onSave={handleClick}
                  isloading={isLoading}
                  flag={4}
                />
              )}
            </>
          }
        />

        {showExportWarning && (
          <ImportProgressWarning
            warningToggle={exportwarningToggle}
            setShowWarning={setShowExportWarning}
            onOk={exportwarningToggle}
            message={warningMessage}
          />
        )}

        {showImpExpRedirect && (
          <ImpExpRedirectPopup
            onProceed={() => {
              setShowImpExpRedirect(false);
              setfirstRequest(true);
              importuserToggle();
            }}
            onCancel={() => setShowImpExpRedirect(false)}
          />
        )}

        <MDBModal open={importUser} onClose={() => setimportUser(false)} tabIndex='-1'>
          <MDBModalDialog size="fullscreen">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>Import User Template</MDBModalTitle>
              </MDBModalHeader>
              <MDBModalBody className="pb-0">
                <ImportUser
                  onClose={importuserToggle}
                  setIsloading={setIsloading}
                  onShow={setimportUser}
                  show={importUser}
                  firstRequest={firstRequest}
                  setfirstRequest={setfirstRequest}
                />
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>

        <Tooltip
          anchorSelect=".copyToolTip"
          place="top"
          className="exampleTooltip"
        >
          Copy
        </Tooltip>
        <Tooltip
          anchorSelect=".editToolTip"
          place="top"
          className="exampleTooltip"
        >
          Edit
        </Tooltip>
        <Tooltip
          anchorSelect=".deleteToolTip"
          place="top"
          className="exampleTooltip"
        >
          Remove
        </Tooltip>
      </>
    </React.Fragment>
  );
}
export default CallFlowLanding;
